<div id="authenticated-home" class="container">
  <div class="headlines">
    <span class="mat-toolbar">{{ "app.allGeodataInSight" | translate }}</span>
    <span class="subheadline">Trivis - Powered by Trigonos</span>
  </div>

  <img src="assets/frontpage.jpg" class="frontpage-image" />
</div>
